module.exports = __webpack_public_path__ + "img/tick_large_cross.e6fdadec.png";